/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalContent, ModalHeader, ModalTitle, ModalFooter } from "../ui/Modal";
import Button from "../ui/Button";
import Text from "../ui/Text";
import Stack from "../ui/Stack";
import ButtonGroup from "../ui/ButtonGroup";
import { ROUTES } from "../../constants/constants";
import MembershipServiceCard from "./MembershipServiceCard";

const MembershipSignInModal = ({ isOpen, onClose, service }) => {
  const navigate = useNavigate();
  
  const goToAuth = (tab) => {
    navigate(ROUTES.LOGIN, { state: { tab } });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Sign in to continue</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Stack $gap="1rem">
            <Text color="dark">This service requires a membership. Sign in to check your access or purchase a plan.</Text>
            <MembershipServiceCard service={service} />
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Stack $gap="1rem" $align="center" $justify="center">
            <ButtonGroup itemsWidth="half">
              <Button variant="outline" title="Sign up" onClick={() => goToAuth("sign_up")} />
              <Button variant="primary" onClick={() => goToAuth("sign_in")} title="Sign in"></Button>
            </ButtonGroup>
            <Text color="default">You can continue browsing without signing in</Text>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MembershipSignInModal;
